/**
 * Menu Click Event Handler
 *
 * Tracks clicks on header menu items and sends menu_click events.
 * Global parameters are NOT included (only used in pageview event).
 */

import { gtmLog } from './gtm-logger';

/**
 * Initialise menu click handlers.
 */
const initMenuHandlers = () => {
	const menuItems = document.querySelectorAll(
		'.wp-site-blocks > header :is(.wp-block-button, .wp-block-navigation) a[href]'
	);

	if ( menuItems.length === 0 ) {
		return;
	}

	menuItems.forEach( ( item ) => {
		item.addEventListener( 'click', () => {
			const clickText = item.textContent.trim();

			// Get parent menu item (one level above).
			const menuParent =
				item
					.closest( '.wp-block-navigation__submenu-container' )
					?.closest( '.wp-block-navigation-item' )
					?.querySelector( ':scope > .wp-block-navigation-item__content' )
					?.textContent?.trim() || '';

			// Initialize dataLayer if not exists.
			window.dataLayer = window.dataLayer || [];

			// Build menu_click event.
			const eventData = {
				event: 'menu_click',
				click_text: clickText,
			};

			// Only include menu_parent if it exists.
			if ( menuParent ) {
				eventData.menu_parent = menuParent;
			}

			gtmLog( 'Menu click:', eventData );

			// Push to dataLayer.
			window.dataLayer.push( eventData );
		} );
	} );

	gtmLog( 'Menu handlers initialized:', menuItems.length, 'items' );
};

// Initialize when DOM is ready.
if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initMenuHandlers );
} else {
	initMenuHandlers();
}
